<div class="container mx-auto mt-6 w-full md:px-[3.5rem] px-4 ">
    <h1 class="font-noto-serif text-[var(--dark-teal)]  text-2xl md:text-3xl"> We couldn’t find any matches for “{{query}}” </h1>


    <p class="text-[var(--charcoal)] text-xl mt-10">Want to stay updated? Create a <span
            class="text-[#007BC2] font-bold cursor-pointer" (click)="onPostNewSearch(query)">Saved
            Search</span> to get updates when matching items are added or close to ending.</p>

    <div class="flex justify-center ">
        <fa-icon [icon]="faHeartBroken" class="text-[250px] text-blue-200 items-center"></fa-icon>
    </div>


</div>